import { render, staticRenderFns } from "./RevisionModeController.vue?vue&type=template&id=dc64e11e&"
import script from "./RevisionModeController.vue?vue&type=script&lang=js&"
export * from "./RevisionModeController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports